<template>
  <v-container>
    <v-alert
      class="mt-3 mb-3"
      text
      dense
      color="info"
      border="left"
    >
      <h3 class="alert-title">
        Instruções
      </h3>
      <li class="alert-list__item">
        Para iniciar o parcelamento selecione a taxa abaixo.
      </li>
      <li class="alert-list__item">
        Para ver seus parcelamentos e baixar o DAE clique em
        <strong>MEUS PARCELAMENTOS</strong>.
      </li>
    </v-alert>
    <v-card class="pa-6 elevation-0">
      <section class="d-flex flex-column flex-lg-row flex-sm-column">
        <v-spacer />
        <DialogMeusParcelamentos :contribuinte="userGessan?.nome" />
      </section>
      <v-divider />
      <v-alert
        v-if="semReceitas"
        class="mt-4"
        type="warning"
        text
        border="left"
        prominent
      >
        <strong>Nenhuma taxa disponível para parcelamento.</strong><br>
        Não foram encontradas taxas de repasse aptas para parcelamento vinculadas ao seu CNPJ.
      </v-alert>
      <DialogSimulation
        :list-cards="listCards"
        @updateList="loadDashboard"
      />
    </v-card>
    <AceiteTermosParcelamentoDialog />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import taxaRegulacaoService from "@/services/financeiro/taxa-regulacao.service";
import DialogSimulation from "./DialogSimulation.vue";
import DialogMeusParcelamentos from "./DialogMeusParcelamentos.vue";
import AceiteTermosParcelamentoDialog from "./components/AceiteTermosParcelamentoDialog.vue";

const global = mapState("global", ["userGessan"]);

export default {
  name: "ParcelamentoSaneamento",
  components: {
    DialogSimulation,
    DialogMeusParcelamentos,
    AceiteTermosParcelamentoDialog,
  },
  data: () => ({
    listCards: [
      {
        name: "Taxa",
        idReceita: 1,
        disabled: true,
        list: [
          {
            name: "Taxa de Regulação do Serviço de Saneamento Básico",
            idProduto: 2,
            icon: "article",
            data: { count: 0 },
            disabled: true,
          },
        ],
      },
    ],
    dashboardLoaded: false,
  }),
  computed: {
    ...global,
    semReceitas() {
      return this.dashboardLoaded && this.listCards.every(card => card.disabled);
    },
  },
  mounted() {
    this.loadDashboard();
  },
  methods: {
    loadDashboard() {
      taxaRegulacaoService
        .listReceitasSaneamento({
          cpfCnpj: this.userGessan?.cnpj,
          page: 0,
          size: 10,
          ascendingSort: true,
          sort: ["dataCadastro"],
        })
        .subscribe(
          res => {
            const count = res?.pageInfo?.totalElements ?? 0;

            this.listCards.forEach(card => {
              card.list.forEach(item => {
                item.data = { count };
              });
              card.disabled = card.list.every(produto => !produto.data || produto.data.count === 0);
            });
            this.dashboardLoaded = true;
          },
          () => {
            this.dashboardLoaded = true;
          }
        );
    },
  },
};
</script>
